import { defineComponent as _defineComponent } from 'vue'
import { Exercise, UnknownExercise } from '@ilteducation/exercise-service-types';
import Form from '@/resources/exercises/Form.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Create',
  props: {
    title: null,
    item: null
  },
  setup(__props: any) {



const newExercise: UnknownExercise = {
  author: { name: 'ILT Education', type: 'alias' },
  content: [],
  resourceId: '',
  resourceType: '',
  title: '',
  type: 'quiz',

};

return { __sfc: true,newExercise, Form }
}

})